"use client";

import { c as _c } from "react/compiler-runtime";
import { ChevronDownIcon } from "@heroicons/react/24/solid";
import Link from "next/link";
import { useState } from "react";
import { PrimaryButton } from "@components/common/button";
import { Card, CommitteeHeader } from "@components/common/card";
import { Divider } from "@components/common/divider";
import type { Decision as TDecision } from "@lib/api/decisions/types";
import { routes } from "@lib/navigation";
interface Props {
  decision: TDecision;
}
export default function Decision(t0) {
  const $ = _c(36);
  const {
    decision
  } = t0;
  const [visible, setVisible] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = function toggleVisible() {
      setVisible(_temp);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const toggleVisible = t1;
  let t2;
  if ($[1] !== decision.committee) {
    t2 = <CommitteeHeader committee={decision.committee} />;
    $[1] = decision.committee;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== decision.paragraphTitle) {
    t3 = <p className="text-md mb-2 sm:text-lg">{decision.paragraphTitle}</p>;
    $[3] = decision.paragraphTitle;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== decision.title) {
    t4 = <p className="text-sm text-slate-600 dark:text-slate-300">{decision.title}</p>;
    $[5] = decision.title;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <div>{t3}{t4}</div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <ChevronDownIcon className="h-6 w-6 shrink-0 transition-transform group-aria-expanded:rotate-180 sm:h-8 sm:w-8" />;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5 || $[12] !== visible) {
    t7 = <button className="group flex w-full justify-between gap-4 p-4 text-left" onClick={toggleVisible} aria-expanded={visible}>{t5}{t6}</button>;
    $[11] = t5;
    $[12] = visible;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const t8 = !visible;
  let t9;
  if ($[14] !== t8) {
    t9 = <Divider aria-hidden={t8} className="aria-hidden:hidden" />;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const t10 = !visible;
  let t11;
  if ($[16] !== decision.paragraph) {
    t11 = decision.paragraph && <div className="text-sm [&_p]:my-4" dangerouslySetInnerHTML={{
      __html: decision.paragraph
    }} />;
    $[16] = decision.paragraph;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== decision.id) {
    t12 = routes.document(decision.id);
    $[18] = decision.id;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <PrimaryButton>Läs mer om betänkandet</PrimaryButton>;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== t12) {
    t14 = <Link href={t12} target="_blank">{t13}</Link>;
    $[21] = t12;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== decision.voteSearchTerm || $[24] !== decision.votesExists) {
    t15 = decision.votesExists && <Link href={`${routes.votes}?sok=${encodeURIComponent(decision.voteSearchTerm)}`} target="_blank"><PrimaryButton>Läs mer om voteringarna</PrimaryButton></Link>;
    $[23] = decision.voteSearchTerm;
    $[24] = decision.votesExists;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== t10 || $[27] !== t11 || $[28] !== t14 || $[29] !== t15) {
    t16 = <div aria-hidden={t10} className="flex flex-col gap-4 px-4 pb-4 aria-hidden:hidden">{t11}{t14}{t15}</div>;
    $[26] = t10;
    $[27] = t11;
    $[28] = t14;
    $[29] = t15;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== t16 || $[32] !== t2 || $[33] !== t7 || $[34] !== t9) {
    t17 = <Card className="p-0">{t2}{t7}{t9}{t16}</Card>;
    $[31] = t16;
    $[32] = t2;
    $[33] = t7;
    $[34] = t9;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  return t17;
}
function _temp(prevState) {
  return !prevState;
}